import React from 'react';
import { H3 as TamaguiH3 } from 'tamagui';
import type { TextProps } from 'tamagui';
import { skeleton } from '../../skeleton';

type Props = TextProps & { loading?: boolean; children?: React.ReactNode };

const H3 = ({ children, loading, ...restProps }: Props) => {
  return (
    // @ts-ignore (className)
    <TamaguiH3
      display="block"
      fontSize="$20"
      lineHeight="normal"
      fontWeight="$medium"
      {...restProps}
      className={skeleton.className('line', loading)}
    >
      {children}
    </TamaguiH3>
  );
};

export default H3;
